import GICHolding from "./GICHolding";
import Utils from "../portlibs/PortUtils";
import { GICTransaction } from "./GICTransaction";
import { TFrequency } from "./Price";

export default class BondHolding extends GICHolding {
    get couponInterval() { return {month:6}}
    get frequency() : TFrequency {return "s"}
    getFirstCoupon(trans: GICTransaction): Date {
        let date = trans.maturity
        while(date>trans.date) date = Utils.dateAdd(date, {month:-6})
        return Utils.dateAdd(date, {month:6})
    }
    override computePayout() {
        this.excessDiv = 0;
        return this.resetPayout().computePayoutPerAccount()
    }    
}